import React from 'react';
import { Countdown, Section, BackgroundImage } from './styles';

import TimeBox from '../../components/Countdown/timebox';
import background from '../../assets/MoreInfo/sailingaurora.png';

const MoreInfo: React.FC = () => {

  return (
    <Section id="moreinfo">
      <BackgroundImage src={background} />
      <Countdown>
        <TimeBox />
      </Countdown>
    </Section>
  );
}

export default MoreInfo;